export enum CalculationTranslationEnum {
  UnsupportedLocalization = 'unsupportedLocalization',
  ShowSimulation = 'showSimulation',
  NextStepWithoutShowingSimulation = 'nextStepWithoutShowingSimulation',
}
